import styled, { css } from 'styled-components';
import Link from 'next/link';

import Arrow from 'Elements/Link/Arrow';

export const Container = styled.article`
    ${({ theme }) => css`
        position: relative;
        overflow: hidden;
        height: 100%;
        border-radius: 0.5rem;
        display: grid;
        grid-template-columns: auto 1fr;
        grid-template-rows: 1fr;

        @media ${theme.breakpoints.large.media} {
            grid-template-columns: 1fr;
            grid-template-rows: auto 1fr;
        }
    `}
`;

export const Inner = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const DesktopHeading = styled.h3`
    ${({ theme }) => css`
        display: none;

        @media ${theme.breakpoints.large.media} {
            height: 4rem;
            margin: 0.75rem 0 1rem 0;
            font-size: 1.5rem;
            color: ${theme.colors.accents[5].hex};
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    `}
`;

export const HeadingLink = styled(Link)`
    ${({ theme }) => css`
        font-size: 1.125rem;
        color: ${theme.colors.accents[5].hex};
        margin: 0;
        font-weight: 700;
    `}
`;

export const SmallerScreenHeading = styled.h3`
    ${({ theme }) => css`
        margin: 0;
        line-height: 1;

        @media ${theme.breakpoints.large.media} {
            display: none;
        }
    `}
`;

export const Description = styled.p`
    ${({ theme }) => css`
        display: none;

        @media ${theme.breakpoints.large.media} {
            display: flex;
            font-size: 1.125rem;
            margin-bottom: 1rem;
            color: #4d4d4d;
        }
    `}
`;

export const StyledArrowLink = styled(Arrow)`
    ${({ theme }) => css`
        display: none;

        @media ${theme.breakpoints.large.media} {
            display: inline-flex;
            font-size: 1rem;
        }
    `}
`;

export const ImageWrapper = styled.div`
    ${({ theme }) => css`
        position: relative;
        width: 9.25rem;
        height: 5.25rem;
        min-width: 9.25rem;
        overflow: hidden;
        border-radius: 0.5rem;
        margin-right: 0.875rem;

        @media ${theme.breakpoints.medium.media} {
            margin-right: 0.5rem;
        }

        @media ${theme.breakpoints.large.media} {
            width: 100%;
            height: 11rem;
            margin: 0;
        }
    `}
`;
